export default "__VITE_ASSET__CJOEX70N__"